export default __webpack_public_path__ + "static/media/Defi2.ac1dd86f.png";